import { CoreButton, CoreModalDialogFooter } from '@components'
import ApproveIcon from '@images/expenses/approve-report.svg?react'
import { toastSuccess } from '@utils'
import { ReportActions, useProcessReportMutation } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useEffect } from 'react'
import type { ReportActionModalProps } from '../@types'

import './approveModal.scss'

export const ApproveModal = ({ handleSubmit, reportName, onClose }: ReportActionModalProps) => {
  const [_, { error, isLoading, reset }] = useProcessReportMutation()

  const onConfirm = async () => {
    try {
      await handleSubmit({ action: ReportActions.APPROVE })

      toastSuccess(
        tr('FRONTEND.REPORTS.ACTIONS.APPROVE_SUCCESS', 'The report has been approved successfully'),
        undefined,
        {
          position: 'top-center',
          style: { marginTop: '-50px' }
        }
      )
    } catch {}
  }

  // biome-ignore lint/correctness/useExhaustiveDependencies: reset only on unmount
  useEffect(() => {
    return () => {
      reset()
    }
  }, [])

  return (
    <div className='approve-modal-wrapper'>
      <div className='approve-modal-inner'>
        <div className='icon'>
          <ApproveIcon />
        </div>
        <div className='confirmation'>
          {tr('FRONTEND.REPORTS.ACTIONS.APPROVE_REPORT_DESCRIPTION', 'Are you sure you want to approve report')}:{' '}
          <p>{reportName}</p>
        </div>
      </div>

      <ErrorDisplay error={error} />

      <CoreModalDialogFooter>
        <div className='buttons-container'>
          <CoreButton
            text={tr('FRONTEND.BUTTONS.CONFIRM', 'Confirm')}
            onClick={onConfirm}
            data-test='approve-report-button'
            isLoading={isLoading}
            size='large'
            fullWidth
            variation='primary-black'
          />

          <CoreButton
            variation='tertiary'
            text={tr('FRONTEND.BUTTONS.CANCEL', 'Cancel')}
            onClick={onClose}
            data-test='cancel-reject-report-button'
            isLoading={isLoading}
            size='large'
          />
        </div>
      </CoreModalDialogFooter>
    </div>
  )
}
